import {
  ALTER_CONFIRM_ALERT,
  ALTER_CONFIRM_ALERT_CUSTOM_PARAMETERS,
  HIDE_CONFIRM_ALERT,
} from "../actions/alertConfirmAction";

const initialState = {
  showAlert: false,
  showCustomAlert: false,
  message: "",
  id: "",
  custNums: "",
  value: "",
  additionalItems: [],
  okButtonId: "AlertDialog.Ok",
  okButtonDefaultText: "Ok",
  headerId: "Alert.Header",
  headerDefaultText: "Alert!"
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
		case ALTER_CONFIRM_ALERT:
			return {
				...state,
				showAlert: true,
				message: action.payload.message,
				id: action.payload.id,
				custNums: action.payload.custNums
			};
		case ALTER_CONFIRM_ALERT_CUSTOM_PARAMETERS:
			return {
				...state,
				showCustomAlert: true,
				headerId: action.payload.headerId,
				headerDefaultText: action.payload.headerDefaultText,
				id: action.payload.id,
				message: action.payload.message,
				value: action.payload.value,
				okButtonId: action.payload.okButtonId,
				okButtonDefaultText: action.payload.okButtonDefaultText,
				additionalItems: action.payload.additionalItems
			};
		case HIDE_CONFIRM_ALERT:
			return {
				...state,
				showAlert: false,
				showCustomAlert: false
			};

		default:
			return state;
  }
};

export default alertReducer;
